import {Axios} from '@asocial/fe-utils'
import {AxiosResponse} from 'axios'
import {SearchUser} from 'shared/types'
import {UserType} from './model'

export const GetUserInfo = (idUser: string): Promise<AxiosResponse<UserType | null>> =>
  Axios.get(`users/${idUser}`)

export const GetUserSimilar = (idUser: string): Promise<AxiosResponse<{data: SearchUser[]}>> =>
  Axios.get(`/users/${idUser}/similar`)
